import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useRef } from 'react';
import usePrevious from 'react-utils/hooks/usePrevious';
import { useIsInView } from '../utils/hooks';

const ScrollMarker = ({
  onEnterView
}) => {
  const scrollMarkerRef = useRef(null);
  const isInView = useIsInView(scrollMarkerRef);
  const prevIsInView = usePrevious(isInView);
  useEffect(() => {
    if (isInView && !prevIsInView) {
      onEnterView();
    }
  }, [isInView, onEnterView, prevIsInView]);
  return /*#__PURE__*/_jsx("div", {
    ref: scrollMarkerRef
  });
};

export default ScrollMarker;